import React from 'react';
import { useGlobalContext } from '../../stores/global';
import Button from '../core/Button';
import Modal from './Modal';

export default function GlobalAlert() {
  const { dispatch, alertModal } = useGlobalContext();

  if (!alertModal) {
    return null;
  }

  const handleClose = (reason?: string) => {
    alertModal.onClose?.(reason);
    dispatch({ type: 'SET_ALERT_MODAL', payload: undefined });
  };

  return (
    <Modal open title={alertModal.title} onClose={handleClose}>
      <p style={{ marginBottom: '1em' }}>{alertModal.message}</p>
      {alertModal.details ? (
        <details>
          <summary>{alertModal.details.summary}</summary>
          <p>{alertModal.details.content}</p>
        </details>
      ) : null}
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          label={alertModal.btnLabel || 'CERRAR'}
          onClick={() => handleClose('closeBtn')}
        />
      </div>
    </Modal>
  );
}
